import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { GuiFlowService } from '../../___LOGIC/__gui/gui-flow.service';
import { CrudFieldItemService } from 'src/app/___LOGIC/__crud/crud-field-item.service';
import { CrudFieldsDataService } from 'src/app/___LOGIC/__crud/crud-fields-data.service';
import { CrudFieldsService } from 'src/app/___LOGIC/__crud/crud-fields.service';

@Component({
  selector: 'app-dynamic-crud',
  templateUrl: './dynamic-crud.component.html',
  styleUrls: ['./dynamic-crud.component.css']
})
export class DynamicCrudComponent implements OnInit {

  
  @Input() crudConfig;
  @Input() tableProperties;
  @Input() exportValuesFlag;

  crudFieldsToRender;

  showDebugCard = false;
  DEFAULT_CONFIG = {
    id: 'sebasSEBAS',
    tableName: 'checklistItem',
    cacheLabel: null,
    tableProperties: [],
    table1: 'checklist',
    table2: 'checklistItem',
    tableX: 'itemXchecklist',
    FK_1: 'FK_ID_checklist',
    FK_2: 'FK_ID_checklistItem',
    FK_1_value: null,
    FK_2_value: null,
    queryName: '',
    hiddenInputFields: [],
    mandatoryFields: [
    ],
    preloadedValues: [],
    debugMode: true,
    currentId: null,
    showCreateUpdateButtons: true
  };
  
  @Output() public formDataObj = new EventEmitter();
  
  constructor(private crudFieldsData: CrudFieldsDataService,private crudFieldsService: CrudFieldsService,private guiFlow: GuiFlowService) { }

  ngOnInit(): void {
    !this.crudConfig? this.crudConfig = this.crudFieldsData.registerCrud(this.DEFAULT_CONFIG) : this.crudConfig = this.crudFieldsData.registerCrud(this.crudConfig);
    this.crudFieldsToRender = this.build();
  }

  build() {
    let buff = null;
    // Si el estado es edicion etonces debo traerme el objeto de CrudFieldsData
    let result: CrudFieldItemService[] = [];
    if(this.getCurrentProps().length>0){
      debugger
      
      for (let prop of this.getCurrentProps()) {
        let fieldValue = null;
        if (this.crudFieldsData.isCurrentStatus('update',this.crudConfig.id)){
          this.crudConfig.currentObj = this.crudFieldsData.getCurrentObjectToUpdate(this.crudConfig.id);
          fieldValue = this.crudConfig.currentObj[prop.columnName];
        }else{
          if(this.crudConfig.preloadedValues && this.crudConfig.preloadedValues.length>0){
            let element = this.findObjectByProp(this.crudConfig.preloadedValues,prop.columnName);
            if(element){
              fieldValue = element[prop.columnName];
              this.crudFieldsData.addValueToFieldInObj(prop.columnName,fieldValue,this.crudConfig.id);
            }
          }
        }
        buff = this.crudFieldsService.getHtmlComponentFromProp(prop.dataType, prop.columnName, fieldValue,this.crudConfig.id);
        // TO DO:
        prop.visible? buff = this.crudFieldsService.getHtmlComponentFromProp(prop.dataType, prop.columnName, fieldValue,this.crudConfig.id) : buff = null;
        buff? result.push(buff) : null;
      }
      return result;
    }else{
      return result;
    }
  }

  findObjectByProp(array, propName) {
    return array.find(element => element[propName]);
  }

  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...ç
    if(this.exportValuesFlag){
      this.guiFlow.setCurrentState('create');
      this.crudConfig.currentObj = this.crudFieldsData.getCurrentObj(this.crudConfig.id);
      this.formDataObj.emit(this.crudConfig.currentObj);
    }
  }

  isInputFieldHidden(field){
    if(this.crudConfig && this.crudConfig.hiddenInputFields){
      for(let ele of this.crudConfig.hiddenInputFields){
        if(field === ele){
          return true;
        }
      }
    }
    return false;
  }

  getCurrentProps(){
    if(this.tableProperties && this.tableProperties.length>0){
      // use Input properties
      //console.log('USING INPUT PROPERTIES');
      return this.tableProperties;
    }else{
      if(this.crudFieldsData.getQueryProps(this.crudConfig.id).length >0){
        this.tableProperties = this.crudFieldsData.getQueryProps(this.crudConfig.id);
      }else{  
        this.tableProperties = this.crudConfig.tableProperties;
      }

      if(this.tableProperties.length>0){
        for (let [i, value] of this.crudConfig.tableProperties.entries()) {
          if(this.isInputFieldHidden(value.columnName)){
            this.crudConfig.tableProperties[i].visible = false;
          }else{
            this.crudConfig.tableProperties[i].visible = true;
          }
        }
        return this.crudConfig.tableProperties;
      }else {
        // REFACTOR
        //this.crudFieldsData.getProperties(this.crudConfig.cacheLabel,this.crudConfig.id);
        console.log('Error: no properties object');
        return [];
      }
    }
  }

  addNewRow(){
    this.crudFieldsData.setCurrentStatus('create',this.crudConfig.id);
  }
  
  isCurrentStatus(status){
    return this.crudFieldsData.getCrudStatus(this.crudConfig.id) === status;
  }

  getLastInsertedObjectAsString(){
    return this.crudFieldsData.getLastInsertedObj(this.crudConfig.id);
  }

  getCurrentObjectAsString(){
    return JSON.stringify(this.crudFieldsData.getCurrentObj(this.crudConfig.id));
  }

  getCurrentStatusAsString(){
    return this.crudFieldsData.getCrudStatus(this.crudConfig.id);
  }

  // UPDATE
  saveChanges(){
    debugger;
    this.crudFieldsData.updateObject(this.crudConfig,'put');
  }

  // CREATE
  create() {
    this.crudConfig.tableX? this.crudFieldsData.createNewFKObject(this.crudConfig,'post') : this.crudFieldsData.createNewObject(this.crudConfig);
    this.formDataObj.emit(this.crudConfig);
  }

  setCurrentStatus(s){
    this.crudFieldsData.setCurrentStatus(s,this.crudConfig.id);
  }

}
